import { urls } from "../../../urls";

export const v1SupplierViewLinkToCurrent = (eventId: string, search: string): string => {
  const params = new URLSearchParams(search);
  const question = params.get("question");
  const announcement = params.get("announcement");

  if (question) return urls.app.supplier.procurement.question(eventId, question);
  if (announcement) return urls.app.supplier.procurement.announcement(eventId, announcement);
  return urls.app.supplier.procurement.go(eventId);
};
